<template>
    <div class="flex flex-col items-center">
        <div class="container">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mt-5">
                <div
                    v-for="product in filteredProducts"
                    :key="product.id"
                    class="bg-white vignette-work-item rounded-[12px] flex-1"
                >
                    <div class="flex flex-col items-center py-4 px-4 text-center">
                        <p class="text-strong-gray text-sm mb-3">
                            {{ cleanTitle(product.translated?.title) }}
                        </p>

                        <p class="mb-4 font-medium text-xl">
                            €{{ product.price ?? '' }}
                        </p>

                        <a :href="product.path"
                           class="inline-flex items-center justify-center py-3 rounded-lg bg-[#F5F7FA] font-normal text-sm w-full" >
                            {{ texts['home-long-section6-1-button'] }}
                        </a>
                    </div>
                </div>
            </div>

            <div v-if="!filteredProducts.length" class="text-gray-500 text-center mt-6">
                No products
            </div>
        </div>
    </div>
</template>

<script>
import ApiClient from "../../core/ApiClient";

function extractCategoryRows(response) {
    const body = response?.data;
    if (!body) return [];
    if (Array.isArray(body)) return body;
    if (typeof body !== 'object') return [];
    if (Array.isArray(body.data)) return body.data;
    if (Array.isArray(body.categories)) return body.categories;
    return [];
}

export default {
    name: 'GetProducts',
    data() {
        return {
            products: []
        }
    },
    mounted() {
        const fromStore = this.$store?.getters?.['form/categorizedProducts'] || [];
        if (fromStore.length) {
            this.applyCarProducts(fromStore);
            return;
        }

        this.$store?.dispatch?.('form/loadInitialData')
            .then(() => this.applyCarProducts(this.$store.getters['form/categorizedProducts'] || []))
            .catch(() => {
                const api = new ApiClient();
                return api.request({ path: '/products/categories' }).then((response) => {
                    this.applyCarProducts(extractCategoryRows(response));
                });
            });
    },
    methods: {
        applyCarProducts(rows) {
            const carRow = (rows || []).find((row) => {
                const title = String(row?.translated?.title ?? row?.title ?? '').trim();
                return title.toLowerCase() === 'car';
            });
            const list = Array.isArray(carRow?.products) ? carRow.products : [];
            this.products = list.map((p) => ({
                ...p,
                category: p.category && typeof p.category === 'object'
                    ? { ...carRow, ...p.category }
                    : carRow,
            }));
        },
        cleanTitle(title) {
            if (!title) return '';
            return title.replace(/^Vignette\s*/i, '');
        }
    },
    computed: {
        texts() {
            return this.$store.getters.texts;
        },
        filteredProducts() {
            return this.products.filter(
                (product) => product.category?.translated?.title === 'Car'
            );
        }
    }
}
</script>
